export const RecFishingConfig = {
  stats: {
    large: [
      {
        name: "# of operators",
        title: "# of recorded operators",
        tooltip:
          "Estimated number of charter vessel operators offering recreational fishing tours; data derived from TripAdvisor and local directory listing provided by TNC Caribbean Division",
          measurement: "(total)",
      },
      {
        name: "Estimated annual tourism expenditure (USD)",
        title: "Estimated annual tourism expenditure",
        tooltip:
          "Estimated based on survey data on costs and number of trips offered per year",
          measurement: "(USD)",
      },
    ],
    small: [
      {
        name: "EEZ area (sqkm)",
        title: "Total EEZ area",
        round: 0,
        tooltip:
          "The total are of the Economic Exclusion Zone. Data are not official, but are taken from the TNC Caribbean Challenge Initiative EEZ statistcs, calculated from the 2018 VLIZ EEZ layer (https://www.marineregions.org/) using a custom Lambert projection centered on the Caribbean.",
          measurement: "(sqkm)",
      },
      {
        name: "% of EEZ used by rec fishing",
        title: "% of EEZ used by rec fishing",
        round: 0,
        tooltip:
          "The area of the recreational fishing footprint divided by the area of the EEZ.",
          measurement: "(% fishing)",
      },
    ],
  },
  data: [
    {
      name: "CROP Countries",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Recreational_Fishing_03292021_WFL1/FeatureServer/0",
    },
    {
      name: "Dominica",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Rec_Fishing_Scaled_per_Country_WFL1/FeatureServer/0",
    },
    {
      name: "Grenada",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Rec_Fishing_Scaled_per_Country_WFL1/FeatureServer/2",
    },
    {
      name: "Saint Kitts and Nevis",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Rec_Fishing_Scaled_per_Country_WFL1/FeatureServer/1",
    },
    {
      name: "Saint Lucia",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Rec_Fishing_Scaled_per_Country_WFL1/FeatureServer/3",
    },
    {
      name: "Saint Vincent and the Grenadines",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/ArcGIS/rest/services/Rec_Fishing_Scaled_per_Country_WFL1/FeatureServer/4",
    },
    {
      name: "Statistics Table",
      url:
        "https://services.arcgis.com/F7DSX1DSNSiWmOqh/arcgis/rest/services/MOWCROP_AppStats_05042021/FeatureServer/0",
    },
  ],
};

export const refLayersToInclude = [
  {
    layer: "Recreational Fishing Operators",
    title: "Fishing Operators",
    tooltip:
      "Locations of charter vessel operators offering fishing excursions based on data from TripAdvisor and local directory listings provided by TNC Caribbean Division",
    measurement:  "",
  },
  {
    layer: "Population Analysis - Number of People",
    title: "Number of People per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: true,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Women",
    title: "Number of Women per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: true,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Elderly",
    title: "Number of Elderly (over 60 years old) per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: false,
      },
      {
        id: 2,
        visible: true,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
  {
    layer: "Population Analysis - Number of Children",
    title: "Number of Children (under 5 years old) per 90 square meters",
    tooltip:
      "High resolution population density maps provided by Facebook Data for Good. These maps combine machine learning techniques with available census data and other statistics. Data are presented by census unit. Non-colored areas show non-populated areas. More information here:",
    link: "www.dataforgood.fb.com/tools/population-density-maps",
    measurement: "",
    sublayers: [
      {
        id: 3,
        visible: true,
      },
      {
        id: 2,
        visible: false,
      },
      {
        id: 1,
        visible: false,
      },
      {
        id: 0,
        visible: false,
      },
    ],
    isRaster: true,
  },
];

export const ReferenceConfig = [
  {
    url:
      "https://oceanwealth.org/wp-content/uploads/2020/12/Output_6_Recreational_Fishing_Report_Final_20201211.pdf",
    label: "Technical Report",
  },
  {
    url:
      "https://oceanwealth.org/wp-content/uploads/2021/06/Recreational-Fishing-Technical-Summary.pdf",
    label: "Technical Summary",
  },
  {
    url: "https://tnc.box.com/shared/static/umkm8vc7fgxde6xx43l6br29r4d1fs7s.zip",
    label: "Data Download",
  },
  {
    url: "https://oceanwealth.org/project-areas/caribbean/crop/country-summaries/",
    label: "Country Summary"
  },
];
